module.exports = __webpack_public_path__ + "static/media/president.a58e2cd8.jpeg";